module.exports = __webpack_public_path__ + "img/xnr5.46deef9c.jpg";